import React, { useCallback, useEffect, useState } from "react";
import "./LandingPage.css";
import {
  Avatar,
  Button,
  Dialog,
  DialogContent,
  IconButton,
  InputAdornment,
  Link,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import { CalendarToday } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import UploadIcon from "@mui/icons-material/Upload";
import axios from "axios";

function LandingPage() {
  const URL = "https://aa035139-3251-4d74-8a2f-845eafc26dc9.mock.pstmn.io/";

  const [data, setData] = useState([]);

  let apiCall = async () => {
    try {
      let response = await axios.get(URL + "v1/videos");
      setData(response.data.videos);
    } catch (error) {
      console.error(error, "error");
    }
  };

  useEffect(() => {
    apiCall();
  }, []);

  // sorting

  const [sortValue, setSortValue] = useState("releaseDate");

  //genre click
  const [genreSelected, setGenreSelected] = useState(["All Genre"]);
  let genreSelector = (genre) => {
    let variableSelected;
    if (genreSelected.includes(genre)) {
      variableSelected = genreSelected.filter((e) => e !== genre);
    } else {
      variableSelected = [...genreSelected, genre];
    }
    setGenreSelected(variableSelected);
  };

  //age click
  const [ageSelected, setAgeSelected] = useState(["Any age group"]);

  let ageSelector = (age) => {
    let variableSelected;

    variableSelected = [age];

    setAgeSelected(variableSelected);
  };

  // filter by genre

  let filter = () => {
    if (
      genreSelected.length === 1 &&
      ageSelected[0] === "Any age group" &&
      genreSelected[0] === "All Genre"
    ) {
      return data.sort((a, b) => {
        if (sortValue === "releaseDate") {
          return new Date(b.releaseDate) - new Date(a.releaseDate);
        } else if (sortValue === "viewCount") {
          return b.viewCount - a.viewCount;
        }
      });
    } else {
      let filteredData = data.filter((e) => {
        let genreMatch = false;
        if (genreSelected.length === 1) {
          genreMatch = true;
        } else {
          genreMatch = genreSelected.some((selected) => {
            return e.genre.includes(selected);
          });
        }
        console.log(genreMatch);
        let ageMatch =
          ageSelected[0] === "Any age group" ||
          ageSelected.includes(e.contentRating);

        let titleMatch = true;
        if (searchText) {
          titleMatch = e.title.toLowerCase().includes(searchText.toLowerCase());
        }

        return genreMatch && ageMatch && titleMatch;
      });
      return filteredData.sort((a, b) => {
        if (sortValue === "releaseDate") {
          return new Date(b.releaseDate) - new Date(a.releaseDate);
        } else if (sortValue === "viewCount") {
          return b.viewCount - a.viewCount;
        }
      });
    }
  };

  //search bar functionality
  const [searchText, setSearchText] = useState("");
  let searchfilter = (searchText) => {
    const filteredSearch = data.filter((e) =>
      e.title.toLowerCase().includes(searchText.toLowerCase())
    );
    setData(filteredSearch);
  };

  //reset

  let resetData = useCallback(() => {
    apiCall();
    setGenreSelected(["All Genre"]);
    setAgeSelected(["Any age group"]);
    setSearchText("");
  }, [apiCall]);

  //dialog modal
  const [open, setOpen] = useState(false);

  useEffect(() => {
    console.log(genreSelected);
    console.log(filter());
  }, [genreSelected]);

  return (
    <div>
      {/* header section */}
      <div className="header">
        <img src="Logo.png" alt="logo.png" onClick={() => resetData()} />
        <div className="searchField" style={{ marginLeft: "250px" }}>
          <TextField
            size="small"
            InputProps={{
              inputProps: {
                placeholder: "Search...",
                style: { color: "#fff", borderColor: "rgba(68, 77, 86, 1)" },
              },
            }}
            onChange={(e) => setSearchText(e.target.value)}
          />
          <IconButton
            variant="contained"
            style={{ color: "rgba(96, 96, 96, 1)" }}
            onClick={() => searchfilter(searchText)}
          >
            <SearchOutlinedIcon />
          </IconButton>
        </div>

        <div className="d-flex col-md-3 justify-content-end">
          <Button
            variant="contained"
            startIcon={<UploadIcon />}
            style={{ fontSize: "12px" }}
            onClick={() => setOpen(true)}
            id="upload-btn"
          >
            Upload
          </Button>

          <Dialog open={open} onClose={() => setOpen(false)}>
            <DialogContent
              sx={{
                color: "#fff",
                backgroundColor: "#000",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                padding: "12px",
                gap: "20px",
                background:
                  "linear-gradient(0deg, rgba(255, 255, 255, 0.16), rgba(255, 255, 255, 0.16)), #121212",
                boxShadow:
                  "0px 24px 38px rgba(0, 0, 0, 0.14), 0px 9px 46px rgba(0, 0, 0, 0.12), 0px 11px 15px rgba(0, 0, 0, 0.2)",
                borderRadius: "4px",
              }}
            >
              <div
                className="dialogDivContent"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  alignItems: "center",
                }}
              >
                <p style={{ marginBottom: "0" }}>Upload Video</p>
                <IconButton
                  id="upload-btn-cancel"
                  onClick={() => setOpen(false)}
                  sx={{ color: "#fff" }}
                >
                  <CloseIcon />
                </IconButton>
              </div>

              <TextField
                label="Video Link"
                variant="outlined"
                sx={{
                  color: "rgba(255, 255, 255, 0.6)",
                  borderRadius: "3.5px",
                  width: "100%",
                  "& .MuiOutlinedInput-root": {
                    borderColor: "#fff",
                  },
                }}
              />
              <TextField
                label="Thumbnail Image Link"
                variant="outlined"
                sx={{
                  color: "rgba(255, 255, 255, 0.6)",
                  borderRadius: "3.5px",
                  width: "100%",
                  "& .MuiOutlinedInput-root": {
                    borderColor: "#fff",
                  },
                }}
              />
              <TextField
                label="Title"
                variant="outlined"
                sx={{
                  color: "rgba(255, 255, 255, 0.6)",
                  borderRadius: "3.5px",
                  width: "100%",
                  "& .MuiOutlinedInput-root": {
                    borderColor: "#fff",
                  },
                }}
              />
              <TextField
                label="Genre"
                variant="outlined"
                select
                defaultValue="Genre"
                value="genre"
                sx={{
                  color: "rgba(255, 255, 255, 0.6)",
                  borderRadius: "3.5px",
                  width: "100%",
                  "& .MuiOutlinedInput-root": {
                    borderColor: "#fff",
                  },
                }}
              >
                <MenuItem value="">Genre</MenuItem>
                <MenuItem value="Education">Education</MenuItem>
                <MenuItem value="Sports">Sports</MenuItem>
                <MenuItem value="Comedy">Comedy</MenuItem>
                <MenuItem value="Lifestyle">Lifestyle</MenuItem>
              </TextField>
              <TextField
                label="Suitable age group for the clip"
                variant="outlined"
                select
                defaultValue="Genre"
                value="genre"
                sx={{
                  color: "rgba(255, 255, 255, 0.6)",
                  borderRadius: "3.5px",
                  width: "100%",
                  "& .MuiOutlinedInput-root": {
                    borderColor: "#fff",
                  },
                }}
              >
                <MenuItem value="7+">7+</MenuItem>
                <MenuItem value="12+">12+</MenuItem>
                <MenuItem value="16+">16+</MenuItem>
                <MenuItem value="18+">18+</MenuItem>
              </TextField>
              <TextField
                variant="outlined"
                label="Select a date"
                sx={{
                  color: "rgba(255, 255, 255, 0.6)",
                  borderRadius: "3.5px",
                  width: "100%",
                  "& .MuiOutlinedInput-root": {
                    borderColor: "#fff",
                  },
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton>
                        <CalendarToday />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <div style={{ display: "flex" }}>
                <Button
                  id="upload-btn-submit"
                  variant="contained"
                  style={{ color: "#fff", backgroundColor: "red" }}
                >
                  UPLOAD VIDEO
                </Button>
                <Button
                  variant="text"
                  style={{ color: "#fff" }}
                  onClick={() => setOpen(false)}
                >
                  CANCEL
                </Button>
              </div>
            </DialogContent>
          </Dialog>

          <Avatar
            alt="Remy Sharp"
            src="https://example.com/avatar.jpg"
            style={{ marginLeft: "10px" }}
          />
        </div>
      </div>
      {/* header section */}
      {/* filter section */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          backgroundColor: "rgba(32, 32, 32, 1)",
          justifyContent: "center",
        }}
      >
        <div className="genre_filter">
          <Button
            className="genre-btn"
            label="All Genre"
            value="All Genre"
            variant="filled"
            style={{
              color:
                genreSelected.length === 1 ? "rgba(88, 96, 105, 1)" : "#fff",
              backgroundColor:
                genreSelected.length === 1 ? "#fff" : "rgba(32, 32, 32, 1)",
              borderRadius: "20px",
              textTransform: "none",
            }}
            onClick={() => setGenreSelected(["All Genre"])}
          >
            All Genre
          </Button>

          <Button
            className="genre-btn"
            label="Education"
            variant="filled"
            style={{
              color: genreSelected.includes("Education")
                ? "rgba(88, 96, 105, 1)"
                : "#fff",
              backgroundColor: genreSelected.includes("Education")
                ? "#fff"
                : "rgba(32, 32, 32, 1)",
              borderRadius: "20px",
              marginLeft: "10px",
              textTransform: "none",
            }}
            value="Education"
            onClick={(e) => genreSelector(e.target.value)}
          >
            Education
          </Button>
          <Button
            className="genre-btn"
            label="Sports"
            variant="filled"
            value="Sports"
            onClick={(e) => genreSelector(e.target.value)}
            style={{
              color: genreSelected.includes("Sports")
                ? "rgba(88, 96, 105, 1)"
                : "#fff",
              backgroundColor: genreSelected.includes("Sports")
                ? "#fff"
                : "rgba(32, 32, 32, 1)",
              borderRadius: "20px",
              marginLeft: "10px",
              textTransform: "none",
            }}
          >
            Sports
          </Button>

          <Button
            className="genre-btn"
            label="Comedy"
            variant="filled"
            value="Comedy"
            onClick={(e) => genreSelector(e.target.value)}
            style={{
              color: genreSelected.includes("Comedy")
                ? "rgba(88, 96, 105, 1)"
                : "#fff",
              backgroundColor: genreSelected.includes("Comedy")
                ? "#fff"
                : "rgba(32, 32, 32, 1)",
              borderRadius: "20px",
              marginLeft: "10px",
              textTransform: "none",
            }}
          >
            Comedy
          </Button>

          <Button
            className="genre-btn"
            label="Lifestyle"
            variant="filled"
            value="Lifestyle"
            onClick={(e) => genreSelector(e.target.value)}
            style={{
              color: genreSelected.includes("Lifestyle")
                ? "rgba(88, 96, 105, 1)"
                : "#fff",
              backgroundColor: genreSelected.includes("Lifestyle")
                ? "#fff"
                : "rgba(32, 32, 32, 1)",
              borderRadius: "20px",
              marginLeft: "10px",
              textTransform: "none",
            }}
          >
            Lifestyle
          </Button>
        </div>

        <Select
          value={sortValue}
          onChange={(e) => setSortValue(e.target.value)}
          sx={{
            textTransform: "none",
            color: "rgba(32, 32, 32, 1)",
            backgroundColor: "#fff",
            borderRadius: "20px",
          }}
          size="small"
        >
          <MenuItem
            value="releaseDate"
            id="release-date-option"
            className="sort-select"
          >
            <SwapVertIcon /> Release Date
          </MenuItem>
          <MenuItem value="viewCount" id="view-count-option" className="sort-select">
            <SwapVertIcon /> View Count
          </MenuItem>
        </Select>
        {/* <select
              title="sortBy"
              className="sort-select"
              defaultValue={"Release Date"}
              onChange={(e) => setSortValue(e.target.value)}
              
              // sx={{borderRadius:'20px'}}
            >
              <option value={"releaseDate"} id="release-date-option" selected>
                Release Date
              </option>
              <option value={"viewCount"} id="view-count-option">
                View Count
              </option>
            </select> */}
      </div>
      <div className="genre_filter">
        <Button
          className="content-rating-btn"
          label="Any age group"
          variant="filled"
          value="Any age group"
          onClick={(e) => ageSelector(e.target.value)}
          style={{
            color: ageSelected.includes("Any age group")
              ? "rgba(88, 96, 105, 1)"
              : "#fff",
            backgroundColor: ageSelected.includes("Any age group")
              ? "#fff"
              : "rgba(32, 32, 32, 1)",
            borderRadius: "20px",
            marginLeft: "10px",
            textTransform: "none",
          }}
        >
          Any age group
        </Button>
        <Button
          className="content-rating-btn"
          label="7+"
          variant="filled"
          value="7+"
          onClick={(e) => ageSelector(e.target.value)}
          style={{
            color: ageSelected.includes("7+") ? "rgba(88, 96, 105, 1)" : "#fff",
            backgroundColor: ageSelected.includes("7+")
              ? "#fff"
              : "rgba(32, 32, 32, 1)",
            borderRadius: "20px",
            marginLeft: "10px",
          }}
        >
          7+
        </Button>
        <Button
          className="content-rating-btn"
          label="12+"
          variant="filled"
          value="12+"
          onClick={(e) => ageSelector(e.target.value)}
          style={{
            color: ageSelected.includes("12+")
              ? "rgba(88, 96, 105, 1)"
              : "#fff",
            backgroundColor: ageSelected.includes("12+")
              ? "#fff"
              : "rgba(32, 32, 32, 1)",
            borderRadius: "20px",
            marginLeft: "10px",
          }}
        >
          12+
        </Button>
        <Button
          className="content-rating-btn"
          label="16+"
          variant="filled"
          value="16+"
          onClick={(e) => ageSelector(e.target.value)}
          style={{
            color: ageSelected.includes("16+")
              ? "rgba(88, 96, 105, 1)"
              : "#fff",
            backgroundColor: ageSelected.includes("16+")
              ? "#fff"
              : "rgba(32, 32, 32, 1)",
            borderRadius: "20px",
            marginLeft: "10px",
          }}
        >
          16+
        </Button>
        <Button
          className="content-rating-btn"
          label="18+"
          variant="filled"
          value="18+"
          onClick={(e) => ageSelector(e.target.value)}
          style={{
            color: ageSelected.includes("18+")
              ? "rgba(88, 96, 105, 1)"
              : "#fff",
            backgroundColor: ageSelected.includes("18+")
              ? "#fff"
              : "rgba(32, 32, 32, 1)",
            borderRadius: "20px",
            marginLeft: "10px",
          }}
        >
          18+
        </Button>
      </div>
      {/* filter section */}
      {/* cards section */}
      <div className="row">
        {filter()
          ? filter().map((e) => {
              let todayDate = new Date();
              let startDate = new Date(e.releaseDate);
              let difference = todayDate.getTime() - startDate.getTime();
              let noOfdays = difference / (1000 * 60 * 60 * 24);
              let displayDate = "";
              if (noOfdays >= 7 && noOfdays < 30) {
                displayDate = Math.floor(noOfdays / 7) + " weeks ago";
              } else if (noOfdays >= 30 && noOfdays < 365) {
                displayDate = Math.floor(noOfdays / 30) + " months ago";
              } else if (noOfdays > 365) {
                displayDate = Math.floor(noOfdays / 365) + " days ago";
              } else {
                displayDate = noOfdays + " day";
              }
              return (
                <div className="col-md-3 cards video-tile" id={e._id}>
                  <Link
                    className="video-tile-link"
                    underline="none"
                    href={`/video/${e._id}`}
                  >
                    <img
                      src={e.previewImage}
                      alt=""
                      style={{ borderRadius: "10px" }}
                    />
                    <div
                      style={{ textAlign: "start", marginLeft: "20px" }}
                      className="video-tile"
                    >
                      <h5 style={{ color: "#fff" }}>{e.title}</h5>
                      <p style={{ color: "#fff" }}>{displayDate}</p>
                    </div>
                  </Link>
                </div>
              );
            })
          : ""}
      </div>
      {/* cards section */}
    </div>
  );
}

export default LandingPage;
